import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7387c24e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "chr-achievements-progress",
  class: "tw-flex tw-flex-col tw-items-start tw-gap-[40px] tw-self-stretch tw-bg-[#ffffff]"
}
const _hoisted_2 = { class: "tw-w-full tw-flex tw-justify-center tw-items-start tw-flex-col tw-gap-[12px] !tw-break-inside-avoid" }
const _hoisted_3 = { class: "tw-flex tw-justify-between tw-w-[100%] tw-h-[36px]" }
const _hoisted_4 = {
  id: "chr-sheading-achievement",
  class: "tw-text-[#211F58] tw-text-[24px] tw-font-semibold"
}
const _hoisted_5 = { class: "tw-text-[#231F20] tw-text-[14px] tw-font-normal tw-w-[70%] tw-opacity-[0.7]" }

import { getComponentUiText } from "@/utils/utilities";
import { computed, Ref } from "vue";
import AchievementsAndProgressTable from "./achievementsAndProgressTable.vue";
import Pen from "@/components/svgs/pen.vue";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'achievementsAndProgress',
  props: {
  isLoading: {
    type: Boolean,
    default: true,
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:edit", "on-form-invalid"],
  setup(__props, { emit }) {

const props = __props;


const customTableData = computed(() => {
  const data = store.getters["Sharing/getChecklistReportData"];
  if (!data?.checklistHistory) return [];

  return data.checklistHistory.map((item, idx, arr) => {
    const score = Math.round(item.checklistHistoryScore * 100);
    const nextScore =
      idx < arr.length - 1
        ? Math.round(arr[idx + 1].checklistHistoryScore * 100)
        : score;
    return {
      ...item,
      checklistHistoryScore: score,
      checklistHistoryImprovementScore: score - nextScore,
    };
  });
});



const editNotes = () => {
  emit("update:edit", !props.isEdit);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getComponentUiText)("app-report-achievements-and-progress-title-1")), 1),
        _createElementVNode("div", {
          id: "pen-icon-achievements",
          class: _normalizeClass([__props.isEdit ? 'is_editable' : 'not_editable', "header__pen tw-cursor-pointer"]),
          onClick: editNotes
        }, [
          _createVNode(Pen, {
            color: __props.isEdit ? '#ffffff' : '#387DFF'
          }, null, 8, ["color"])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(getComponentUiText)("app-report-achievements-and-progress-sub-title-1")), 1)
    ]),
    _createVNode(AchievementsAndProgressTable, {
      data: customTableData.value,
      "is-show-edit": __props.isEdit,
      "is-loading": __props.isLoading,
      onOnFormInvalid: _cache[0] || (_cache[0] = (val) => emit('on-form-invalid', val))
    }, null, 8, ["data", "is-show-edit", "is-loading"])
  ]))
}
}

})